export default __webpack_public_path__ + "static/media/jz.2f22bd33.jpg";